module.exports = __webpack_public_path__ + "static/media/pakiet_1200X900_02kubek.f80c3a0a.jpg";